/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid200,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid400,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid401,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid500,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboardClassroomdisciplineid.ts";
import { correctionDashboardDetailItemRepositoryResponsePaginatedResponseSchema } from "../correctionDashboardDetailItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamCorrectionDashboardClassroomdisciplineidPathParamsSchema =
  z.object({
    classroomDisciplineId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams>;

export const getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParamsSchema =
  z.object({
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(10),
  }) as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectionDashboardClassroomdisciplineid200Schema =
  z.lazy(
    () =>
      correctionDashboardDetailItemRepositoryResponsePaginatedResponseSchema,
  ) as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectionDashboardClassroomdisciplineid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectionDashboardClassroomdisciplineid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectionDashboardClassroomdisciplineid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineid500>;

export const getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamCorrectionDashboardClassroomdisciplineid200Schema,
  ) as unknown as ToZod<GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse>;
